import { TemplateTypes } from './templateTypes';

export const tabs = {
  CART_ABANDONMENTS: 'cart_abandonments',
  BROWSE_ABANDONMENTS: 'browse_abandonments',
  SUBJECT_LINES: 'subject_lines',
  UNSUBSCRIBES: 'unsubscribes',
  BULK_RETARGETING: 'bulk_retargeting',
  SMS_CART_ABANDONMENTS: 'sms_cart_abandonments',
  DATA_ACQUISITION: 'data_acquisition',
  SEND_MY_BASKET: 'send_my_basket',
  DISPLAY_ONLY: 'display_only',
  MPS_EMBED: 'MPS_EMBED',
  MPS_POPUP: 'MPS_POPUP',
} as const;

export const MOBILE_CHANNEL_TAB_IDS = [tabs.CART_ABANDONMENTS, tabs.BROWSE_ABANDONMENTS] as const;

export const DEFAULT_TABS: Record<string, string> = {
  onsite: tabs.DATA_ACQUISITION,
  mps: tabs.MPS_EMBED,
  sms: tabs.CART_ABANDONMENTS,
  rcs: tabs.CART_ABANDONMENTS,
  email: tabs.CART_ABANDONMENTS,
};

export const getDefaultTabForChannel = (channel: string | undefined): string =>
  DEFAULT_TABS[channel || 'email'] || DEFAULT_TABS.email;

export const TAB_TO_TEMPLATE_TYPE: Record<string, string> = {
  [tabs.CART_ABANDONMENTS]: TemplateTypes.cartAbandonment,
  [tabs.BROWSE_ABANDONMENTS]: TemplateTypes.browseAbandonment,
  [tabs.DATA_ACQUISITION]: TemplateTypes.dataAcquisition,
  [tabs.SEND_MY_BASKET]: TemplateTypes.sendMyBasket,
  [tabs.DISPLAY_ONLY]: TemplateTypes.displayOnly,
  [tabs.MPS_EMBED]: TemplateTypes.mpsEmbed,
  [tabs.MPS_POPUP]: TemplateTypes.mpsPopup,
  [tabs.BULK_RETARGETING]: TemplateTypes.bulkRetargeting,
  [tabs.UNSUBSCRIBES]: TemplateTypes.unsubscribe,
};
